import type { ComputedRef } from 'vue';

export type PublicFlowAdapter = {
    actorEmail: ComputedRef<string | undefined>;
    apiUrl: string;
    baseUrl: string;
    brandUrl?: string;
    refreshAuthenticatedState?: () => Promise<void>;
    navigate: (path: string, transition?: 'next' | 'prev') => void | Promise<void>;
    back: (fallback: string) => void | Promise<void>;
    open: (url: string) => void | Promise<void>;
    logout: () => void | Promise<void>;
};

let publicFlowAdapter: PublicFlowAdapter | undefined;

export function providePublicFlowAdapter(adapter: PublicFlowAdapter) {
    publicFlowAdapter = adapter;
}

export function usePublicFlowAdapter() {
    if (!publicFlowAdapter) {
        throw new Error('Public flow adapter is not available.');
    }

    return publicFlowAdapter;
}
